// extracted by mini-css-extract-plugin
module.exports = {"StockCommodity":"StockCommodity_StockCommodity___aa_p","news":"StockCommodity_news__Sj_qx","news-list":"StockCommodity_news-list__O9dtT","chart":"StockCommodity_chart__lkWAv"};